import './polyfills';
import i18ninit from './i18n';
import { createApp } from './createApp';
import config from './temp/config.js';
import logger from './globalHandler/logging';
import {loggingConfig} from './globalHandler/logger-config.js';

/* eslint-disable no-underscore-dangle */

let initLanguage = config.defaultLanguage;
let configPath = '/envConfig/config.json';
// The config path is different in Sitecore Server SSR... Make sure we get the 
let __JSS_STATE__ = null;
const ssrRawJson = document.getElementById('__JSS_STATE__');
if (ssrRawJson) {
  __JSS_STATE__ = JSON.parse(ssrRawJson.innerHTML);
}
if (__JSS_STATE__) {
  // set i18n language SSR state language instead of static config default language
  configPath = '/dist/iol/envConfig/config.json';
}

fetch(configPath)
  .then((response) => response.json())
  .then((config => {
    return main(config)
}))

async function main (envConfig) {
  
  /*
    SSR Data
    If we're running in a server-side rendering scenario,
    the server will provide the window.__JSS_STATE__ object
    for us to acquire the initial state to run with on the client.

    This enables us to skip a network request to load up the layout data.

    SSR is initiated from /server/server.js.
  */
  let __JSS_STATE__ = null;
  const ssrRawJson = document.getElementById('__JSS_STATE__');
  if (ssrRawJson) {
    __JSS_STATE__ = JSON.parse(ssrRawJson.innerHTML);
  }
  if (__JSS_STATE__) {
    // set i18n language SSR state language instead of static config default language
    initLanguage = __JSS_STATE__.sitecore.context.language;
  }

  const initialState = __JSS_STATE__ || null;

  // HTML element to place the app into
  const rootElement = document.getElementById('root');

  // initialize the dictionary, then render the app
  // note: if not making a multlingual app, the dictionary init can be removed.

  // Customisation Standalone
  // - make call to retrieve all the manifest content from local json file
  // - store it so we can access it throughout the application
  let log = new logger(loggingConfig, envConfig.appInsightId);

  if (process.env.VUE_APP_JssStandAlone === 'true') {
    // Create a logger here as the Vue App is not created yet...
    try {
      const response = await fetch('/sitecore-manifest.json');
      const manifest =  await response.json();
      const finalDictionary = manifest.dictionary.reduce(function(result, current) {
        // eslint-disable-next-line no-param-reassign
        result[current.key] = current.value;
        return result;
      }, {});
      const i18n = await i18ninit(initLanguage, finalDictionary, envConfig)
      const {app} = createApp(initialState, i18n, log, envConfig);
      app.$jss.store.setStandAloneManifest(manifest);
      app.$mount(rootElement);
    } catch (e) {
      // error handler - file not generated issue
      if(log && typeof(log)!== 'undefined'){
        log.error('Error:', e);
      } else {
        console.log(e)
      }
    }
  }
  // end custom code
  else {
    i18ninit(initLanguage, null, envConfig).then((i18n)=>{
      // Dictionary call to sitecore returned nicely - then start the app
      const {app} = createApp(initialState, i18n, log, envConfig);
      app.$mount(rootElement);
    }).catch((error)=>{
      // error handler - file not generated issue
      if(log && typeof(log)!== 'undefined'){
        log.error('Error:', error);
      } else {
        console.error(error)
      }
 
      // Sitecore did not respond through dictionary call... then redirect to maintenance page...
      if(typeof(window)!='undefined'){
        window.location.assign('/maintenance.html');
      }
    })
  }
}